import http from './http'

class CourseApi {
	// 查询课程
	static getMemberCourse(params) {
		return http.httpGet('/lavrock/member/manager/memberVideos', params)
	}
	/**
	 * 根据videoId获取对应课程信息
	 * @param {Object} params
	 */
	static getMemberCourseById(params) {
		return http.httpGet('/lavrock/member/manager/memberVideosById', params)
	}
	/**
	 * 更新视频信息
	 * @param {Object} params
	 */
	static updateCourseInfo(params) {
		return http.httpGet('/lavrock/member/manager/playAndPerCnt', params)
	}
	/**
	 * 获取视频分类
	 */
	static getCourseType() {
		return http.httpPost('/lavrock/videoType/manager/findVideoPType')
	}
	/**
	 * 保存播放次数
	 */
	static savePlayCount(params) {
		return http.httpGet('/lavrock/member/manager/addPlayCnt', params)
	}
	/**
	 * 添加学习人数次数
	 */
	static saveUserCount(params) {
		return http.httpGet('/lavrock/member/manager/addUserCnt', params)
	}

	static updateKnowed(params) {
		return http.httpGet('/lavrock/member/manager/updateKnowed', params)
	}
}

export default CourseApi
